import { useTranslation } from 'react-i18next';
import FeatureTile, {
    FeatureItem,
    FeatureTileComponent,
} from '../../FeatureTile/FeatureTile';
import { useSelector } from '../../../../store/hooks';
import { useFeatureStatus } from '../../healthUtils';
import { LuggageRegular } from '@fluentui/react-icons';
import { useMemo } from 'react';
import moment from 'moment';

const formatDateTime = (utc: string): string => {
    if (!utc) return '';
    return moment.utc(utc).format('DD/MM HH:mm');
};

const BaggageTile: FeatureTileComponent = ({ className }) => {
    const { t } = useTranslation();

    const { healthInfo } = useSelector((x) => x.healthDashboard);

    const info = healthInfo?.baggage;

    const status = useFeatureStatus(
        info && (info.unknownErrorCount > 0 || info.validationErrorCount > 0),
        info?.lastSuccessOnUtc,
        info?.lastErrorOnUtc
    );

    const items = useMemo<FeatureItem[]>(() => {
        const unkownValue = '?';

        const lastSuccess = info?.lastSuccessOnUtc
            ? formatDateTime(info.lastSuccessOnUtc)
            : unkownValue;

        return [
            {
                id: 'lastSuccessOn',
                label: t('Health_Baggage_LastSuccessOn').replace(
                    '{dateTime}',
                    lastSuccess
                ),
                status: 'Ok',
            },
            {
                id: 'validationErrorCount',
                label: t('Health_Baggage_ValidationErrorCount').replace(
                    '{count}',
                    info?.validationErrorCount.toString() ?? unkownValue
                ),
                status: 'Warning',
            },
            {
                id: 'unknownErrorCount',
                label: t('Health_Baggage_UnknownErrorCount').replace(
                    '{count}',
                    info?.unknownErrorCount.toString() ?? unkownValue
                ),
                status: 'Error',
            },
        ];
    }, [info, t]);

    return (
        <FeatureTile
            title={t('Health_Baggage_Title')}
            icon={<LuggageRegular />}
            status={status}
            items={items}
            className={className}
        />
    );
};

export default BaggageTile;
